var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNewsletter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4151 12.5874L25.5557 13.5559C25.0173 13.7383 24.433 13.4497 24.2506 12.9113C24.0683 12.3729 24.3569 11.7886 24.8953 11.6062L28.321 10.4459C29.5755 10.021 30.8178 11.1177 30.5518 12.4152L27.2128 28.7006C26.9589 29.939 25.4981 30.4867 24.4926 29.7204L19.9282 26.2419L17.4584 28.2496C16.5785 28.9649 15.2591 28.6448 14.8047 27.6059L12.3097 21.9015L9.90733 21.0878C8.40845 20.5801 8.3379 18.4864 9.79919 17.879L19.5126 13.8412C20.0375 13.623 20.6399 13.8717 20.8581 14.3966C21.0763 14.9215 20.8276 15.5239 20.3027 15.7421L11.4303 19.4302L13.1136 20.0004C13.5707 20.1552 13.9415 20.4955 14.1349 20.9377L16.51 26.3677L18.8393 24.4742C19.454 23.9745 20.331 23.9607 20.9611 24.441L25.306 27.7521L28.4151 12.5874Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1888 17.0668C25.6483 17.1817 25.9277 17.6474 25.8129 18.107L24.4405 23.5963C24.3256 24.0559 23.8599 24.3353 23.4004 24.2204C22.9408 24.1055 22.6614 23.6398 22.7763 23.1803L24.1486 17.6909C24.2635 17.2313 24.7292 16.9519 25.1888 17.0668Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNewsletter);
export default __webpack_public_path__ + "static/media/ic_newsletter.f0768986ff0740e4502d6464086c014b.svg";
export { ForwardRef as ReactComponent };